import { StockRuleType } from '../enums/stock-rule-type.enum';
import { IProduct } from './i-product';

export interface IReportSales {
  totalValue: number;
  totalTaxAmount?: number;
  totalGoodsValue?: number;
  sales: IReportSalesItem[];
}

export interface IReportSalesItem {
  orderId: string;
  reference: string;
  createdAt: string;
  fulfilledAt?: string;
  value: number;
  currencySymbol: string;
  country: string;
  customer: { locationName: string; entity: string; contactNumber?: string };
  operatorName: string;
  locationName: string;
  externalOrderId?: string;
  externalInvoiceId?: string;
  batchId?: string;
  itemName?: string;
  description?: string;
  goodsValue?: number;
  taxAmount?: number;
  deliveryHandshake?: any;
}

export interface ITaxReport {
  totalGoodsValue: number;
  totalTaxAmount: number;
  totalValue: number;
  items: ITaxReportItem[];
}

export interface ITaxReportItem {
  invoiceNumber: string;
  invoiceDate: string;
  customerName: string;
  description: string;
  goodsValue: number;
  taxAmount: number;
  total: number;
}

export interface IReportStock {
  items: IReportStockItem[];
}

export interface IReportStockItem {
  product: IProduct[];
  locationProductStocks: IReportStockLocationProductStock[];
}

export interface IStockBelowMinimumItem {
  product: {
    id: string;
    name: string;
  };
  location: {
    id: string;
    name: string;
    type: string;
  };
  currentStock: number;
  minimumStockLevel: number;
  stockDeficit: number;
  cost: number;
  price: number;
}
export interface IStockMinimumStockRule {
  id: string;
  ruleType: StockRuleType; //'minimumStock';
  location: {
    id: string;
    name: string;
    type: 'locationType';
  };
  product: {
    id: string;
    name: string;
  };
  value: number;
  createdAt: string;
  updatedAt: string;
}

export interface IReportStockLocationProductStock {
  locationId: string;
  locationName: string;
  stockCount: number;
  reservedStockCount: number;
  remainingStockCount: number;
  taxRate: number;
  cost: number;
  price: number;
}

export interface IProductWithStock {
  name: string;
  stockCount: number;
  price: number;
}
